import { LocalStyles } from "@paperbits/common/styles";

export class ConfirmPasswordModel {
    /**
     * Widget local styles.
     */
    public styles: LocalStyles = {};
}
